import { Box, Divider, styled } from '@mui/material';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { PoolRow, PoolTooltip, PoolTypography } from '@synergy/components-next';
import { ReactElement } from 'react';

import { PackingUnit } from '../../../models/packing-units';
import { useArticleDetailContext } from '../article-detail';

const StyledPoolRow = styled(PoolRow)(({ theme }) => ({
    justifyContent: 'space-between',
    height: 47.5,
    padding: theme.spacing(0, 0.5),

    '&:hover': {
        backgroundColor: theme.palette.action.hover,
        cursor: 'pointer',
    },
}));

export const ArticleDetailPackingUnits = (): ReactElement | null => {
    const { article, onChangeOrderQuantity } = useArticleDetailContext();
    const { packingUnits, orderUnit } = article;

    const handlePackingUnitClick = (packingUnit: PackingUnit): void => {
        onChangeOrderQuantity(packingUnit.minimumQuantity);
    };

    return (
        <>
            <PoolTypography variant="statusLabel" sx={{ padding: '0 4px' }}>
                <FormattedMessage id="app.article.detail.packingUnits" />
            </PoolTypography>

            <Box>
                {packingUnits.map(packingUnit => (
                    <Box key={packingUnit.id}>
                        <PoolTooltip title={<FormattedMessage id="app.article.detail.changeOrderQuantity" />}>
                            <StyledPoolRow typography="body2" onClick={() => handlePackingUnitClick(packingUnit)}>
                                {packingUnit.unitName}
                                <Box>
                                    <FormattedNumber value={packingUnit.minimumQuantity} /> {orderUnit}
                                </Box>
                            </StyledPoolRow>
                        </PoolTooltip>
                        <Divider />
                    </Box>
                ))}
            </Box>
        </>
    );
};
